import { action } from 'typesafe-actions';
import { ListarVeiculosTypes, IListarVeiculos, IFilter, Pagination } from './types';

export const loadRequest = (
  inscricoesEstaduais: number[],
  filtro?: IFilter | any,
  pagination?: Pagination
) => action(ListarVeiculosTypes.LOAD_REQUEST, { inscricoesEstaduais, filtro, pagination });

export const loadSuccess = (data: IListarVeiculos[], pagination: Pagination) =>
  action(ListarVeiculosTypes.LOAD_SUCCESS, { data, pagination });

export const loadFailure = () => action(ListarVeiculosTypes.LOAD_FAILURE, {});
export const cleanVeiculos = () => action(ListarVeiculosTypes.CLEAN_MOVIENTRADA);
export const loadFilter = (filter: any) => action(ListarVeiculosTypes.FILTER, { filter });
